import './callPage.css';
import { useState, useEffect, useRef } from "react";
import { createRoot } from 'react-dom/client';
import ShadowDOM from 'react-shadow';
import BASE_URL from '../../config';
import axios from 'axios';
import { MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { FaPhoneAlt, FaVideo } from 'react-icons/fa';
import { FiRotateCw } from 'react-icons/fi'
import '../../assets/styles/card.css';
import { useSip } from './sipContext';
import { useLocation } from 'react-router-dom';

function CallPage() {
// Get SIP context for shared session management
const {
  sipClient,
  activeSession: contextActiveSession,
  setActiveSession: setContextActiveSession,
  sessions,
  incomingCall,
  setIncomingCall,
  getUniqueID: contextGetUniqueID,
} = useSip();
const location = useLocation();

const [devices, setDevices] = useState([]);
const [loadingDevices, setLoadingDevices] = useState(true);
const [selectedUid, setSelectedUid] = useState('');
const [selectedSerial, setSelectedSerial] = useState('');
const [selectedPw, setSelectedPw] = useState('');
const token = localStorage.getItem('jwt_token');

  const [isVisible, setIsVisible] = useState(false); 
//   const [accountData, setAccountData] = useState({
//        Display:  '65'+ selectedSerial.replace(/^SG/, ''),
//        User: '65'+ selectedSerial.replace(/^SG/, ''),

//       //  Display:  '65099',
//      // User: '65099',

//       WSServer: "wss://pbx.mavistech.cloud:8089/ws",
//       Pass: '2QZiiyiF',
//       Realm: "pbx.mavistech.cloud",
//     });
const [rotation, setRotation] = useState(0);
const [activeSession, setActiveSession] = useState(null);
const [isCallActive, setIsCallActive] = useState(false);

  const handleRotate = () => {
    // Rotate by 90 degrees each time
    const newRotation = (rotation + 90) % 360;
    setRotation(newRotation);
  };


 const videoRef = useRef(null);
  const [zoom, setZoom] = useState(1);

  const handleZoom = (delta) => {
    setZoom((prev) => {
      const newZoom = Math.min(Math.max(prev + delta, 1), 3); // clamp zoom between 1x and 3x
      return newZoom;
    });
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.style.transform = `scale(${zoom})`;
    }
  }, [zoom]);

const [accountData, setAccountData] = useState({
  Display: '',
  User: '',
 WSServer: 'wss://pbx.mavistech.cloud:8089/ws',
   //WSServer: 'wss://demo.itcallinfo.info:8089/ws',
  //Pass: '2QZiiyiF',
  Pass: '',
  Realm: 'pbx.mavistech.cloud',
   //Realm: 'demo.itcallinfo.info',
});
//Videp False
  const [callStatus, setCallStatus] = useState({ audio: true, video: false });

const handleVideoCall = async () => {
  const sipCredentialssavedData = localStorage.getItem("sipCredentials");
  if (!sipCredentialssavedData) {
    console.error("No SIP credentials found in localStorage");
    return;
  }

  const parsedSipData = JSON.parse(sipCredentialssavedData);
  const userSipValue = parsedSipData.User;

  if (!userSipValue) {
    console.error("User value not found in SIP credentials");
    return;
  }

  const target = '55' + userSipValue.slice(2); // Generate endpoint

  try {
    const response = await fetch('https://pbx2.mavistech.cloud/api/calls/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        endpoint: target,
        destination: userSipValue,
        action: 'videooriginate',
        token: 'c5f5010245d1a5e3b203421e9b4d9d7891b15e45',
      }),
    });

    const data = await response.json();
    console.log('Video Call Response:', data);
  } catch (error) {
    console.error('Video Call Error:', error);
  }
};


const handleAudioCall = async () => {
  const sipCredentialssavedData = localStorage.getItem("sipCredentials");
  if (!sipCredentialssavedData) {
    console.error("No SIP credentials found in localStorage");
    return;
  }

  const parsedSipData = JSON.parse(sipCredentialssavedData);
  const userSipValue = parsedSipData.User;

  if (!userSipValue) {
    console.error("User value not found in SIP credentials");
    return;
  }

  const target = '55' + userSipValue.slice(2);

  try {
    const response = await fetch('https://pbx2.mavistech.cloud/api/calls/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        endpoint: target,
        destination: userSipValue,
        action: 'originate',
        token: 'c5f5010245d1a5e3b203421e9b4d9d7891b15e45',
      }),
    });

    const data = await response.json();
    console.log('Audio Call Response:', data);
  } catch (error) {
    console.error('Audio Call Error:', error);
  }
};



// useEffect(() => {
//   const fetchDevices = async () => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/api/get_cust_devices/`,
//         {},
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const deviceList = response.data;
//       setDevices(deviceList);

//       // Auto-select the first device if the list is not empty
//       if (deviceList.length > 0) {
//         setSelectedUid(deviceList[0].uid);
//       }
//     } catch (error) {
//       console.error('Error fetching devices:', error);
//     } finally {
//       setLoadingDevices(false);
//     }
//   };

//   fetchDevices();
// }, []);



//   useEffect(() => {
 
//     const link = document.createElement('link');
//    link.href = "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/css/bootstrap.min.css";
//     link.rel = "stylesheet";
//     link.id = "bootstrap-css"; // Add an ID so we can remove it later
//     document.head.appendChild(link);

//     // Cleanup function to remove the CSS when component unmounts
//     return () => {
//       const existingLink = document.getElementById('bootstrap-css');
//       if (existingLink) {
//         document.head.removeChild(existingLink);
//       }
//   };
// }, []);






  // Load saved data from localStorage when the component mounts
  useEffect(() => {

      const fetchDevices = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/get_cust_devices/`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const deviceList = response.data;
      setDevices(deviceList);

      // Auto-select the first device if the list is not empty
if (deviceList.length > 0) {
  const firstDevice = deviceList[0];
  const formatted = '65' + firstDevice.serial.replace(/^SG/, '');
  setSelectedUid(firstDevice.uid);
  setSelectedSerial(firstDevice.serial);

  const updatedData = {
  ...accountData,
  Display: formatted,
  User: formatted,
  Pass: firstDevice.custpbx
};
setAccountData(updatedData);

localStorage.setItem("sipCredentials", JSON.stringify(updatedData));
}



    } catch (error) {
      console.error('Error fetching devices:', error);
    } finally {
      setLoadingDevices(false);
    }
  };

  fetchDevices();


    const savedData = localStorage.getItem("sipCredentials");

    if (savedData) {
      var user = JSON.parse(savedData);
      setAccountData(JSON.parse(savedData)); // Parse and update state

      
       // var ctxSip;


        window.$(document).ready(function() {

            if (typeof(user) === 'undefined') {
                user = JSON.parse(localStorage.getItem('SIPCreds'));
            }
            window.ctxSip = {
                config : {
                    password        : user.Pass,
                    authorizationUser: user.User,
                    displayName     : user.Display,
                    uri             : user.User +'@'+ user.Realm,
                    transportOptions: {                
                        wsServers	: user.WSServer,
                        traceSip	: true
                    },
                    registerOptions	: {
                        expires: 180
                    },
                    hackWssInTransport: true,
                    log	: {
                        builtinEnabled	: true,
                        level	: 3
                    },
                },		
                ringtone     : document.getElementById('ringtone'),
                ringbacktone : document.getElementById('ringbacktone'),
                dtmfTone     : document.getElementById('dtmfTone'),
                Sessions     : [],
                callTimers   : {},
                callActiveID : null,
                callVolume   : 1,
                Stream       : null,

                /**
                 * Parses a SIP uri and returns a formatted US phone number.
                 *
                 * @param  {string} phone number or uri to format
                 * @return {string}       formatted number
                 */
                formatPhone : function(phone) {
                    var num;
                    
                    if (phone.indexOf('@')) {
                        num =  phone.split('@')[0];
                    } else {
                        num = phone;
                    }

                    num = num.toString().replace(/[^0-9]/g, '');

                    if (num.length === 10) {
                        return '(' + num.substr(0, 3) + ') ' + num.substr(3, 3) + '-' + num.substr(6,4);
                    } else if (num.length === 11) {
                        return '0' + num.substr(2);
                    } else {
                        return num;
                    }
                },

                // Sound methods
                startRingTone : function() {
                    try { ctxSip.ringtone.play(); } catch (e) { }
                },

                stopRingTone : function() {
                    try { ctxSip.ringtone.pause(); } catch (e) { }
                },

                startRingbackTone : function() {
                    try { ctxSip.ringbacktone.play(); } catch (e) { }
                },

                stopRingbackTone : function() {
                    try { ctxSip.ringbacktone.pause(); } catch (e) { }
                },

                // Genereates a rendom string to ID a call
                getUniqueID : function() {
                    return Math.random().toString(36).substr(2, 9);
                },

                newSession : function(newSess) {

                    newSess.displayName = newSess.remoteIdentity.displayName || newSess.remoteIdentity.uri.user;
                    newSess.ctxid       = ctxSip.getUniqueID();

                    var status;

                    if (newSess.direction === 'incoming') {
                        status = "Incoming: "+ newSess.displayName;
                        ctxSip.startRingTone();
                        // Set activeSession for incoming calls
                        setActiveSession(newSess);
                        
                    } else {
                        status = "Trying: "+ newSess.displayName;
                        ctxSip.startRingbackTone();
                    }

                    ctxSip.logCall(newSess, 'ringing');

                    ctxSip.setCallSessionStatus(status);

                    // EVENT CALLBACKS
                    var localVideo = document.getElementById('localVideo');
                    var remoteVideo = document.getElementById('remoteVideo');
                    
                    newSess.on('trackAdded', function() {
                        // Declare a RTCPeerConnection			  
                        var pc = newSess.sessionDescriptionHandler.peerConnection;			  
                        // Gets remote tracks. The getReceivers method is a webrtc native method.
                        var remoteStream = new MediaStream();
                        pc.getReceivers().forEach(function(receiver) {
                            remoteStream.addTrack(receiver.track);
                            console.log(receiver.track);
                        });
                        remoteVideo.srcObject = remoteStream;
                        var playPromise = remoteVideo.play();
                        
                        //To  get rid of the issue: caught (in promise) DOMException: The play() request was interrupted by a new load request.
                        if (playPromise !== undefined) {
                            playPromise.then(_ => {
                            // Automatic playback started!
                            // Show playing UI.
                            }).catch(error => {
                            // Auto-play was prevented
                            // Show paused UI.
                            });
                        }
                        
                        setTimeout(() => {
                            // Gets local tracks. The getSenders method is a webrtc native method.
                            var localStream = new MediaStream();
                            pc.getSenders().forEach(function(sender) {
                                //only require tracks in each sender 
                                if(sender.track){
                                    localStream.addTrack(sender.track);
                                    console.log(sender.track);
                                }
                            });
                            
                            localVideo.srcObject = localStream;				
                            var playPromiseLocal = localVideo.play();
                            
                            //To  get rid of the issue: caught (in promise) DOMException: The play() request was interrupted by a new load request.
                            if (playPromiseLocal !== undefined) {
                                playPromiseLocal.then(_ => {
                                // Automatic playback started!
                                // Show playing UI.
                                }).catch(error => {
                                // Auto-play was prevented
                                // Show paused UI.
                                });
                            }				
                        }, 500);

                    
                    });
                    
                    newSess.on('progress',function(e) {
                        if (e.direction === 'outgoing') {
                            ctxSip.setCallSessionStatus('Calling...');
                        }
                    });

                    newSess.on('connecting',function(e) {
                        if (e.direction === 'outgoing') {
                            ctxSip.setCallSessionStatus('Connecting...');
                        }
                    });

                    newSess.on('accepted',function(e) {
                        // If there is another active call, hold it
                        if (ctxSip.callActiveID && ctxSip.callActiveID !== newSess.ctxid) {
                            ctxSip.phoneHoldButtonPressed(ctxSip.callActiveID);
                        }

                        ctxSip.stopRingbackTone();
                        ctxSip.stopRingTone();
                        ctxSip.setCallSessionStatus('Answered');
                        try {
                            ctxSip.logCall(newSess, 'answered');
                        } catch (logErr) {
                            // Never let a call-log/UI error propagate into SIP.js's internal
                            // promise chain - that would cause it to tear down the live call.
                            console.error('Error logging call (non-fatal):', logErr);
                        }
                        ctxSip.callActiveID = newSess.ctxid;

                        // Update React state and sync to context
                        setActiveSession(newSess);
                        setIsCallActive(true);
                        if (typeof setContextActiveSession === 'function') {
                            setContextActiveSession(newSess);
                        }
                        console.log('Call accepted, setting active session:', newSess);
                    });

                    newSess.on('hold', function(e) {
                        ctxSip.callActiveID = null;
                        ctxSip.logCall(newSess, 'holding');
                        ctxSip.setCallSessionStatus("Holding");
                    });

                    newSess.on('unhold', function(e) {
                        ctxSip.logCall(newSess, 'resumed');
                        ctxSip.callActiveID = newSess.ctxid;
                        ctxSip.setCallSessionStatus("Answered");
                    });

                    newSess.on('muted', function(e) {
                        ctxSip.Sessions[newSess.ctxid].isMuted = true;
                        ctxSip.setCallSessionStatus("Muted");
                    });

                    newSess.on('unmuted', function(e) {
                        ctxSip.Sessions[newSess.ctxid].isMuted = false;
                        ctxSip.setCallSessionStatus("Answered");
                    });

                    newSess.on('cancel', function(e) {
                        ctxSip.stopRingTone();
                        ctxSip.stopRingbackTone();
                        ctxSip.setCallSessionStatus("Canceled");
                        if (this.direction === 'outgoing') {
                            ctxSip.callActiveID = null;
                            newSess             = null;
                            ctxSip.logCall(this, 'ended');
                        }
                    });

                    newSess.on('bye', function(e) {
                        ctxSip.stopRingTone();
                        ctxSip.stopRingbackTone();
                        ctxSip.setCallSessionStatus("");
                        ctxSip.logCall(newSess, 'ended');
                        ctxSip.callActiveID = null;

                        // Update React state and sync to context
                        setActiveSession(null);
                        setIsCallActive(false);
                        if (typeof setContextActiveSession === 'function') {
                            setContextActiveSession(null);
                        }
                        console.log('Call ended, clearing active session');
                        newSess = null;
                    });

                    newSess.on('failed', function(e) {
                        ctxSip.stopRingTone();
                        ctxSip.stopRingbackTone();
                        ctxSip.setCallSessionStatus('Terminated');

                        // Update React state and sync to context
                        setActiveSession(null);
                        setIsCallActive(false);
                        if (typeof setContextActiveSession === 'function') {
                            setContextActiveSession(null);
                        }
                        console.log('Call failed, clearing active session');
                    });

                    newSess.on('rejected', function(e) {
                        ctxSip.stopRingTone();
                        ctxSip.stopRingbackTone();
                        ctxSip.setCallSessionStatus('Rejected');
                        ctxSip.callActiveID = null;

                        // Update React state and sync to context
                        setActiveSession(null);
                        setIsCallActive(false);
                        if (typeof setContextActiveSession === 'function') {
                            setContextActiveSession(null);
                        }
                        console.log('Call rejected, clearing active session');
                        newSess = null;
                    });
                
                    ctxSip.Sessions[newSess.ctxid] = newSess;

                },

                /**
                 * sets the ui call status field
                 *
                 * @param {string} status
                 */
                setCallSessionStatus : function(status) {
                    window.$('#txtCallStatus').html(status);
                },

                /**
                 * sets the ui connection status field
                 *
                 * @param {string} status
                 */
                setStatus : function(status) {
                    window.$("#txtRegStatus").html('<i class="fa fa-signal"></i> '+status);
                },

                /**
                 * logs a call to localstorage
                 *
                 * @param  {object} session
                 * @param  {string} status Enum 'ringing', 'answered', 'ended', 'holding', 'resumed'
                 */
                logCall : function(session, status) {

                    var log = {
                            clid : session.displayName,
                            uri  : session.remoteIdentity.uri.toString(),
                            id   : session.ctxid,
                            time : new Date().getTime()
                        },
                        calllog = JSON.parse(localStorage.getItem('sipCalls'));

                    if (!calllog) { calllog = {}; }

                    if (!calllog.hasOwnProperty(session.ctxid)) {
                        calllog[log.id] = {
                            id    : log.id,
                            clid  : log.clid,
                            uri   : log.uri,
                            start : log.time,
                            flow  : session.direction
                        };
                    }

                    if (status === 'ended') {
                        calllog[log.id].stop = log.time;
                    }

                    if (status === 'ended' && calllog[log.id].status === 'ringing') {
                        calllog[log.id].status = 'missed';
                    } else {
                        calllog[log.id].status = status;
                    }

                    localStorage.setItem('sipCalls', JSON.stringify(calllog));
                    ctxSip.logShow();
                },

                /**
                 * adds a ui item to the call log
                 *
                 * @param  {object} item log item
                 */
                logItem : function(item) {

                    var callActive = (item.status !== 'ended' && item.status !== 'missed'),
                        callLength = (item.status !== 'ended')? '<span id="'+item.id+'"></span>': window.moment.duration(item.stop - item.start).humanize(),
                        callClass  = '',
                        callIcon,
                        i;

                    switch (item.status) {
                        case 'ringing'  :
                            callClass = 'list-group-item-success';
                            callIcon  = 'fa-bell';
                            break;

                        case 'missed'   :
                            callClass = 'list-group-item-danger';
                            if (item.flow === "incoming") { callIcon = 'fa-chevron-left'; }
                            if (item.flow === "outgoing") { callIcon = 'fa-chevron-right'; }
                            break;

                        case 'holding'  :
                            callClass = 'list-group-item-warning';
                            callIcon  = 'fa-pause';
                            break;

                        case 'answered' :
                        case 'resumed'  :
                            callClass = 'list-group-item-info';
                            callIcon  = 'fa-phone-square';
                            break;

                        case 'ended'  :
                            if (item.flow === "incoming") { callIcon = 'fa-chevron-left'; }
                            if (item.flow === "outgoing") { callIcon = 'fa-chevron-right'; }
                            break;

                        default :
                            break;
                    }


                    i  = '<div class="list-group-item sip-logitem clearfix '+callClass+'" data-uri="'+item.uri+'" data-sessionid="'+item.id+'" title="Double Click to Call">';
                    i += '<div class="clearfix"><div class="pull-left">';
                   // i += '<i class="fa fa-fw '+callIcon+' fa-fw"></i> <strong>'+ctxSip.formatPhone(item.uri)+'</strong><br><small>'+window.moment(item.start).format('MM/DD hh:mm:ss a')+'</small>';
                   i += '<i class="fa fa-fw '+callIcon+' fa-fw"></i> <small>'+window.moment(item.start).format('MM/DD hh:mm:ss a')+'</small>';
                    i += '</div>';
                    // i += '<div class="pull-left text-left"><em>'+item.clid+'</em><br>' + callLength+'</div></div>';
                     i += '<div class="pull-left text-left"><br>' + callLength+'</div></div>';

                    if (callActive) {
                        i += '<div class="btn-group btn-group-xs pull-right">';
                        if (item.status === 'ringing' && item.flow === 'incoming') {
                            i += '<button class="btn btn-xs btn-success btnCall" title="Call"><i class="fa fa-phone"></i></button>';
                        } else {
                            i += '<button class="btn btn-xs btn-primary btnHoldResume" title="Hold"><i class="fa fa-pause"></i></button>';
                            i += '<button class="btn btn-xs btn-info btnTransfer" title="Transfer"><i class="fa fa-random"></i></button>';
                            i += '<button class="btn btn-xs btn-warning  btnMute" title="Mute"><i class="fa fa-fw fa-microphone"></i></button>';
                        }
                        i += '<button class="btn btn-xs btn-danger btnHangUp" title="Hangup"><i class="fa fa-stop"></i></button>';
                        i += '</div>';
                    }
                    i += '</div>';

                    window.$('#sip-logitems').append(i);


                    // Start call timer on answer
                    if (item.status === 'answered') {
                        var tEle = document.getElementById(item.id);
                        ctxSip.callTimers[item.id] = new Stopwatch(tEle);
                        ctxSip.callTimers[item.id].start();
                    }

                    if (callActive && item.status !== 'ringing') {
                        ctxSip.callTimers[item.id].start({startTime : item.start});
                    }

                    window.$('#sip-logitems').scrollTop(0);
                },

                /**
                 * updates the call log ui
                 */
                logShow : function() {

                    var calllog = JSON.parse(localStorage.getItem('sipCalls')),
                        x       = [];

                    if (calllog !== null) {

                        window.$('#sip-splash').addClass('hide');
                        window.$('#sip-log').removeClass('hide');

                        // empty existing logs
                        window.$('#sip-logitems').empty();

                        // JS doesn't guarantee property order so
                        // create an array with the start time as
                        // the key and sort by that.

                        // Add start time to array
                        window.$.each(calllog, function(k,v) {
                            x.push(v);
                        });

                        // sort descending
                        x.sort(function(a, b) {
                            return b.start - a.start;
                        });

                       // Limit to 15 most recent calls
                        x = x.slice(0, 15);

                        window.$.each(x, function(k, v) {
                            ctxSip.logItem(v);
                        });

                    } else {
                        window.$('#sip-splash').removeClass('hide');
                        window.$('#sip-log').addClass('hide');
                    }
                },

                /**
                 * removes log items from localstorage and updates the UI
                 */
                logClear : function() {

                    localStorage.removeItem('sipCalls');
                    ctxSip.logShow();
                },

                sipCall : function(target) {

                    try {
                        var outgoingSession = ctxSip.phone.invite(target, {
                            sessionDescriptionHandlerOptions : {
                              // Videp False
                                constraints : { audio : true, video : false }               
                            }
                        });
                        outgoingSession.direction = 'outgoing';
                        ctxSip.newSession(outgoingSession);		  

                    } catch(e) {
                        throw(e);
                    }
                },

             audioSipCall : function(target) {

                    try {
                        var outgoingSession = ctxSip.phone.invite(target, {
                            sessionDescriptionHandlerOptions : {
                                constraints : { audio : true, video : false }               
                            }
                        });
                        outgoingSession.direction = 'outgoing';
                        ctxSip.newSession(outgoingSession);		  

                    } catch(e) {
                        throw(e);
                    }
                },

                sipTransfer : function(sessionid) {

                    var s      = ctxSip.Sessions[sessionid],
                        target = window.prompt('Enter destination number', '');

                    ctxSip.setCallSessionStatus('<i>Transfering the call...</i>');
                    s.refer(target);
                },

                sipHangUp : function(sessionid) {

                    var s = ctxSip.Sessions[sessionid];
                    // s.terminate();
                    if (!s) {
                        return;
                    } else if (s.startTime) {
                        s.bye();
                    } else if (s.reject) {
                        s.reject();
                    } else if (s.cancel) {
                        s.cancel();
                    }

                },

                sipSendDTMF : function(digit) {

                    try { ctxSip.dtmfTone.play(); } catch(e) { }

                    var a = ctxSip.callActiveID;
                    if (a) {
                        var s = ctxSip.Sessions[a];
                        s.dtmf(digit);
                    }
                },
                    // Call Button Press LOG
                phoneCallButtonPressed : function(sessionid) {
                const sipCredentialssavedData = localStorage.getItem("sipCredentials");
                const parsedsipData = JSON.parse(sipCredentialssavedData);
                const userSipValue = parsedsipData.User;

                    var s      = ctxSip.Sessions[sessionid],
                       // target = window.$("#numDisplay").val();
                     
                      // target = '55033';
                     target = '55' + userSipValue.slice(2);
                     
                  //  target = '55101';
                    if (!s) {

                        window.$("#numDisplay").val("");
                        ctxSip.sipCall(target);

                    } else if (s.accept && !s.startTime) {                
                        console.log('LOG: Audio true, video : false');
                        s.accept({
                            sessionDescriptionHandlerOptions : {
                                constraints : { audio : true, video : false }                       
                            }
                        });
                    }
                },

                audioCallButtonPressed : function(sessionid) {
                const sipCredentialssavedData = localStorage.getItem("sipCredentials");
                const parsedsipData = JSON.parse(sipCredentialssavedData);
                const userSipValue = parsedsipData.User;

                    var s   = ctxSip.Sessions[sessionid],
                       // target = window.$("#numDisplay").val();

                      // target = '55033';
                     target = '55' + userSipValue.slice(2);

                  //  target = '55101';
                    if (!s) {
                        console.log("LOG:audioCallButtonPressed 1 ");

                        window.$("#numDisplay").val("");
                        ctxSip.audioSipCall(target);

                    } else if (s.accept && !s.startTime) {
                        console.log('LOG: Audio true, video : true');
                        s.accept({
                            sessionDescriptionHandlerOptions : {
                                constraints : { audio : true, video : false }
                            }
                        });
                    }
                },

                phoneSharedContactCallButtonPressed : function(sessionid) {
                const sipCredentialssavedData = localStorage.getItem("sipCredentials");
                const parsedsipData = JSON.parse(sipCredentialssavedData);
                const userSipValue = parsedsipData.User;

                    var s      = ctxSip.Sessions[sessionid],
                     target = '45' + userSipValue.slice(2);

                    if (!s) {
                        window.$("#numDisplay").val("");
                        ctxSip.sipCall(target);

                    } else if (s.accept && !s.startTime) {
                        console.log('LOG: Shared Contact Call - Audio true, video : false');
                        s.accept({
                            sessionDescriptionHandlerOptions : {
                                constraints : { audio : true, video : false }
                            }
                        });
                    }
                },

                phoneMuteButtonPressed : function (sessionid) {

                    var s = ctxSip.Sessions[sessionid];

                    if (!s.isMuted) {
                        s.mute();
                    } else {
                        s.unmute();
                    }
                },

                phoneHoldButtonPressed : function(sessionid) {

                    var s = ctxSip.Sessions[sessionid];
                    var direction = s.sessionDescriptionHandler.getDirection();

                    if (direction === 'sendrecv') {
                        console.log('Call is not on hold');
                        s.hold();
                    } else {
                        console.log('Call is on hold');
                        s.unhold();
                    }
                },


                setError : function(err, title, msg, closable) {

                    // Show modal if err = true
                    if (err === true) {
                        window.$("#mdlError p").html(msg);
                        window.$("#mdlError").modal('show');

                        if (closable) {
                            var b = '<button type="button" class="close" data-dismiss="modal">&times;</button>';
                            window.$("#mdlError .modal-header").find('button').remove();
                            window.$("#mdlError .modal-header").prepend(b);
                            window.$("#mdlError .modal-title").html(title);
                            window.$("#mdlError").modal({ keyboard : true });
                        } else {
                            window.$("#mdlError .modal-header").find('button').remove();
                            window.$("#mdlError .modal-title").html(title);
                            window.$("#mdlError").modal({ keyboard : false });
                        }
                    //   window.$('#numDisplay').prop('disabled', 'disabled');
                    } else {
                        window.$('#numDisplay').removeProp('disabled');
                        window.$("#mdlError").modal('hide');
                    }
                },

                /**
                 * Tests for a capable browser, return bool, and shows an
                 * error modal on fail.
                 */
                hasWebRTC : function() {

                    if (navigator.webkitGetUserMedia) {
                        return true;
                    } else if (navigator.mozGetUserMedia) {
                        return true;
                    } else if (navigator.getUserMedia) {
                        return true;
                    } else {
                       // ctxSip.setError(true, 'Unsupported Browser.', 'Your browser does not support the features required for this phone.');
                       // window.console.error("WebRTC support not found");
                       // return false;
                       return true;
                    }
                }
            };
const ctxSip = window.ctxSip;




            

            // Throw an error if the browser can't hack it.
            if (!ctxSip.hasWebRTC()) {
                return true;
            }




            
            // Use context's SIP client if available, otherwise create new one
            ctxSip.phone = sipClient || new window.SIP.UA(ctxSip.config);

            // If sipClient was already registered before this page mounted (e.g. navigating
            // via sidebar), the 'registered' event won't fire again. Set status immediately.
            if (sipClient && sipClient.isRegistered && sipClient.isRegistered()) {
                ctxSip.setError(false);
                ctxSip.setStatus("Online");
            }

            ctxSip.phone.on('connected', function(e) {
                ctxSip.setStatus("Connected");
                ctxSip.setError(false)
            });

            ctxSip.phone.on('disconnected', function(e) {
                ctxSip.setStatus("Disconnected");

                // disable phone
                ctxSip.setError(true, 'Websocket Disconnected.', 'An Error occurred connecting to the websocket.');

            });

            ctxSip.phone.on('registered', function(e) {
                ctxSip.setError(false)
                var closeEditorWarning = function() {
                    return 'If you close this window, you will not be able to make or receive calls from your browser.';
                };

                var closePhone = function() {
                    // stop the phone on unload
                    localStorage.removeItem('ctxPhone');
                    ctxSip.phone.stop();
                };

                window.onbeforeunload = closeEditorWarning;
                window.onunload       = closePhone;

                // This key is set to prevent multiple windows.
                localStorage.setItem('ctxPhone', 'true');

                window.$("#mldError").modal('hide');
                ctxSip.setStatus("Online");

            });
        

            ctxSip.phone.on('registrationFailed', function(e) {
                console.log(e)
                ctxSip.setError(true, 'Registration Error.', 'An Error occurred registering your phone. Check your settings.');
                ctxSip.setStatus("Error: Registration Failed");
            });

            ctxSip.phone.on('unregistered', function(e) {
                ctxSip.setError(true, 'Registration Error.', 'An Error occurred registering your phone. Please wait while we try to connect it again.');
                ctxSip.setStatus("Error: Registration Failed");
            });

            ctxSip.phone.on('invite', 
            
            function (incomingSession) {
            
                var s = incomingSession;
            
                s.direction = 'incoming';
            ctxSip.newSession(s);

            
            },);

            // Auto-focus number input on backspace.
            window.$('#sipClient').keydown(function(event) {
                if (event.which === 8) {
                    window.$('#numDisplay').focus();
                }
            });

            window.$('#numDisplay').keypress(function(e) {
                // Enter pressed? so Dial.
                if (e.which === 13) {
                    ctxSip.phoneCallButtonPressed();
                }
            });


            window.$('#phoneIcon').click(function(event) {
                // Enter pressed? so Dial.
                event.preventDefault();
                ctxSip.phoneCallButtonPressed();
            });


            window.$('.digit').click(function(event) {
                event.preventDefault();
                var num = window.$('#numDisplay').val(),
                    dig = window.$(this).data('digit');

                window.$('#numDisplay').val(num+dig);

                ctxSip.sipSendDTMF(dig);
                return false;
            });

            window.$('#phoneUI .dropdown-menu').click(function(e) {
                e.preventDefault();
            });

            window.$('#phoneUI').delegate('.btnCall', 'click', function(event) {
                ctxSip.phoneCallButtonPressed();
                // to close the dropdown
                return true;
            });

            window.$('#phoneUI').delegate('.btnSharedCall', 'click', function(event) {
                ctxSip.phoneSharedContactCallButtonPressed();
                // to close the dropdown
                return true;
            });

            window.$('#phoneUI').delegate('.audioBtnCall', 'click', function(event) {
                ctxSip.audioCallButtonPressed();
                // to close the dropdown
                return true;
            });

            window.$('.sipLogClear').click(function(event) {
                event.preventDefault();
                ctxSip.logClear();
            });

            window.$('#sip-logitems').delegate('.sip-logitem .btnCall', 'click', function(event) {
                var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
                ctxSip.phoneCallButtonPressed(sessionid);
                return false;
            });

            window.$('#sip-logitems').delegate('.sip-logitem .btnHoldResume', 'click', function(event) {
                var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
                ctxSip.phoneHoldButtonPressed(sessionid);
                return false;
            });

            window.$('#sip-logitems').delegate('.sip-logitem .btnHangUp', 'click', function(event) {
                var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
                ctxSip.sipHangUp(sessionid);
                return false;
            });

            window.$('#sip-logitems').delegate('.sip-logitem .btnTransfer', 'click', function(event) {
                var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
                ctxSip.sipTransfer(sessionid);
                return false;
            });

            window.$('#sip-logitems').delegate('.sip-logitem .btnMute', 'click', function(event) {
                var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
                ctxSip.phoneMuteButtonPressed(sessionid);
                return false;
            });

            window.$('#sip-logitems').delegate('.sip-logitem', 'dblclick', function(event) {
                event.preventDefault();

                var uri = window.$(this).data('uri');
                window.$('#numDisplay').val(uri);
                ctxSip.phoneCallButtonPressed();
            });

            window.$('#sldVolume').on('change', function() {

                var v      = window.$(this).val() / 100,
                    // player = window.$('audio').get()[0],
                    btn    = window.$('#btnVol'),
                    icon   = window.$('#btnVol').find('i'),
                    active = ctxSip.callActiveID;

                // Set the object and media stream volumes
                if (ctxSip.Sessions[active]) {
                    ctxSip.Sessions[active].player.volume = v;
                    ctxSip.callVolume                     = v;
                }

                // Set the others
                window.$('audio').each(function() {
                    window.$(this).get()[0].volume = v;
                });

                if (v < 0.1) {
                    btn.removeClass(function (index, css) {
                        return (css.match (/(^|\s)btn\S+/g) || []).join(' ');
                        })
                        .addClass('btn btn-sm btn-danger');
                    icon.removeClass().addClass('fa fa-fw fa-volume-off');
                } else if (v < 0.8) {
                    btn.removeClass(function (index, css) {
                        return (css.match (/(^|\s)btn\S+/g) || []).join(' ');
                    }).addClass('btn btn-sm btn-info');
                    icon.removeClass().addClass('fa fa-fw fa-volume-down');
                } else {
                    btn.removeClass(function (index, css) {
                        return (css.match (/(^|\s)btn\S+/g) || []).join(' ');
                    }).addClass('btn btn-sm btn-primary');
                    icon.removeClass().addClass('fa fa-fw fa-volume-up');
                }
                return false;
            });

            // Hide the spalsh after 3 secs.
            setTimeout(function() {
                ctxSip.logShow();
            }, 3000);


            /**
             * Stopwatch object used for call timers
             *
             * @param {dom element} elem
             * @param {[object]} options
             */
            var Stopwatch = function(elem, options) {

                // private functions
                function createTimer() {
                    return document.createElement("span");
                }

                var timer = createTimer(),
                    offset,
                    clock,
                    interval;

                // default options
                options           = options || {};
                options.delay     = options.delay || 1000;
                options.startTime = options.startTime || Date.now();

                // append elements
                elem.appendChild(timer);

                function start() {
                    if (!interval) {
                        offset   = options.startTime;
                        interval = setInterval(update, options.delay);
                    }
                }

                function stop() {
                    if (interval) {
                        clearInterval(interval);
                        interval = null;
                    }
                }

                function reset() {
                    clock = 0;
                    render();
                }

                function update() {
                    clock += delta();
                    render();
                }

                function render() {
                    timer.innerHTML = window.moment(clock).format('mm:ss');
                }

                function delta() {
                    var now = Date.now(),
                        d   = now - offset;

                    offset = now;
                    return d;
                }

                // initialize
                reset();

                // public API
                this.start = start; //function() { start; }
                this.stop  = stop; //function() { stop; }
            };

        });



    }
  }, []);

  // Handle incoming call accepted from popup - accept the call once ctxSip is ready
  useEffect(() => {
    if (location.state?.pendingAccept && incomingCall?.session) {
      const session = incomingCall.session;

      // Wait for ctxSip to be initialized
      const checkAndAccept = () => {
        if (window.ctxSip && window.ctxSip.phone) {
          // Register session with ctxSip
          session.ctxid = session.ctxid || window.ctxSip.getUniqueID();
          window.ctxSip.Sessions[session.ctxid] = session;

          // Accept the call
          session.accept({
            sessionDescriptionHandlerOptions: {
              constraints: { audio: true, video: false },
            },
          });

          // Process through newSession for event handlers
          window.ctxSip.newSession(session);

          // Clear navigation state
          window.history.replaceState({}, document.title);
          setIncomingCall(null);
        } else {
          setTimeout(checkAndAccept, 100);
        }
      };
      checkAndAccept();
    }
  }, [location.state, incomingCall, setIncomingCall]);

  // Sync context active session with local state
  useEffect(() => {
    if (contextActiveSession && !activeSession) {
      setActiveSession(contextActiveSession);
      setIsCallActive(true);
    }
  }, [contextActiveSession, activeSession]);

  // Handle input change
  const handleAccountData = (e) => {
    setAccountData({ ...accountData, [e.target.name]: e.target.value });
    };
  
    // Save to localStorage
  const handleAccountSave = () => {
      localStorage.setItem("sipCredentials", JSON.stringify(accountData));
      setIsVisible(false);
    };

  return (
//   <ShadowDOM.div>
//       <link
//         rel="stylesheet"
//         href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/css/bootstrap.min.css"
//       />

    <div className="App">
      <div className="container-fluid">
          <div className="clearfix sipStatus">
              <div id="txtCallStatus" className="pull-right">&nbsp;</div>
              <div id="txtRegStatus"></div>
          </div>

          {/* Call Controls - Moved to top for better visibility */}
          {isCallActive && activeSession && (
            <div className="call-controls-wrapper">
              <div className="call-controls">
                <button
                  className="call-btn hangup"
                  onClick={() => {
                    activeSession.bye?.();
                    setIsCallActive(false);
                    setActiveSession(null);
                  }}
                >
                  <i className="fa fa-phone-slash"></i> Hang Up
                </button>

                <button
                  className="call-btn hold"
                  onClick={() => {
                    const direction = activeSession.sessionDescriptionHandler.getDirection();
                    if (direction === 'sendrecv') {
                      activeSession.hold();
                    } else {
                      activeSession.unhold();
                    }
                  }}
                >
                  <i className="fa fa-pause"></i> Hold / Resume
                </button>

                <button
                  className="call-btn mute"
                  onClick={() => {
                    if (activeSession.isMuted) {
                      activeSession.unmute();
                    } else {
                      activeSession.mute();
                    }
                  }}
                >
                  <i className="fa fa-microphone-slash"></i> Mute / Unmute
                </button>

                <button
                  className="call-btn transfer"
                  onClick={() => {
                    const target = prompt('Enter SIP address or number to transfer to:');
                    if (target) {
                      activeSession.refer(target);
                    }
                  }}
                >
                  <i className="fa fa-exchange"></i> Transfer
                </button>
              </div>
            </div>
          )}


          {/* Incoming Call Controls */}
          {!isCallActive && activeSession && activeSession.direction === 'incoming' && (
            <div className="call-controls-wrapper">
              <div className="call-controls">

<button
  className="call-btn answer"
  style={{
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    margin: '0 5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }}
  onClick={() => {
    // Make sure ctxSip is accessible in this scope
    if (window.ctxSip && activeSession && activeSession.ctxid) {
      window.ctxSip.phoneCallButtonPressed(activeSession.ctxid);
      setIsCallActive(true);
    } else {
      console.error("Unable to accept call: ctxSip or ctxid missing");
    }
  }}
>
  <i className="fa fa-phone"></i> Answer
</button>


                <button
                  className="call-btn reject"
                  style={{
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '5px',
                    margin: '0 5px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onClick={() => {
                    activeSession.reject();
                    setActiveSession(null);
                  }}
                >
                  <i className="fa fa-phone-slash"></i> Reject
                </button>
              </div>
            </div>
          )}

          <FormControl
            size="small"
            margin="dense"
            variant="outlined"
            sx={{
              width: 250, 
              backgroundColor: '#f9f9f9',
              borderRadius: 1,
            }}
          >
            <InputLabel style={{ paddingTop: '16px' }}>Select a device</InputLabel>

            <Select
              value={selectedUid}
              onChange={(e) => setSelectedUid(e.target.value)}
              label="Select a device"
              disabled={loadingDevices}
              style={{ paddingTop: '16px' }}
              sx={{
                fontSize: '1.000rem',
                '& .MuiSelect-select': {
                  paddingY: 1,
                  paddingX: 2,

                },
              }}
            >
              {devices.map((device) => (
                <MenuItem key={device.uid} value={device.uid}>
                  {device.serial} 
                </MenuItem>
              ))}
            </Select>
          </FormControl>

    {/* <div>
      
      {incomingCall ? (
        <div>
          <p>Incoming call from: {incomingCall.displayName}</p>
<button className="sip-call-btn sip-call-btn-answer" onClick={handleAnswer}>Answer</button>
<button className="sip-call-btn sip-call-btn-reject" onClick={handleReject}>Reject</button>

        </div>
      ) : (
        <p></p>
      )}
    </div> */}

{/* <div className="call-controls-wrapper">

  <div className="call-controls">

    {incomingCall && !clActive && (
      <>
        <button className="call-btn answer" onClick={handleAnswer}>
          ✅ Answer
        </button>
        <button className="call-btn hangup" onClick={handleReject}>
          ❌ Reject
        </button>
      </>
    )}


{clActive && actSession && (
  <>
    <button
      className="call-btn hangup"
      onClick={() => {
        actSession.bye?.();
        setClActive(false);
      }}
    >
      🔴 Hang Up
    </button>

    <button
      className="call-btn hold"
      onClick={() => {
        const direction = actSession.sessionDescriptionHandler.getDirection();
        if (direction === 'sendrecv') {
          actSession.hold();
        } else {
          actSession.unhold();
        }
      }}
    >
      ⏸️ Hold / Resume
    </button>

    <button
      className="call-btn mute"
      onClick={() => {
        if (actSession.isMuted) {
          actSession.unmute();
        } else {
          actSession.mute();
        }
      }}
    >
      🔇 Mute / Unmute
    </button>

    <button
      className="call-btn transfer"
      onClick={() => {
        const target = prompt('Enter SIP address or number to transfer to:');
        if (target) {
          actSession.refer(target);
        }
      }}
    >
      🔁 Transfer
    </button>
  </>
)}

  </div>
</div> */}

          <div className="form-group" id="phoneUI">
              <div className="input-group">
                  {/* <div className="input-group-btn">
                      <button className="btn btn-sm btn-primary dropdown-toggle" data-toggle="dropdown" title="Show Keypad">
                          <i className="fa fa-th"></i>
                      </button>
                      <div id="sip-dialpad" className="dropdown-menu">
                          <button type="button" className="btn btn-default digit" data-digit="1">1<span>&nbsp;</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="2">2<span>ABC</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="3">3<span>DEF</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="4">4<span>GHI</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="5">5<span>JKL</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="6">6<span>MNO</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="7">7<span>PQRS</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="8">8<span>TUV</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="9">9<span>WXYZ</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="*">*<span>&nbsp;</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="0">0<span>+</span></button>
                          <button type="button" className="btn btn-default digit" data-digit="#">#<span>&nbsp;</span></button>
                          <div className="clearfix">&nbsp;</div>
                          <button className="btn btn-success btn-block btnCall" title="Send">
                              <i className="fa fa-play"></i> Send
                          </button>
                      </div>
                  </div> */}
                  {/* <input type="text" name="number" id="numDisplay" className="form-control text-center input-sm" value="" placeholder="Enter number..." autoComplete="off" /> */}


        <div className="text-center w-100" style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>

                         <button className="btn btn-success btn-block btnCall" title="Send" style={{ width: '150px' }}>
                              <i className="fa fa-play"></i> Call Device
                          </button>

                         <button
                            className="btn btn-primary btn-block btnSharedCall"
                            title="Call Shared Contact"
                            style={{ width: '180px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', textTransform: 'none' }}
                          >
                              <i className="fa fa-users"></i> Shared Contact
                          </button>
        </div>
                                {/* <button  className="btn btn-success btn-block audioBtnCall" title="Send">
                              <i className="fa fa-play"></i> Audio Call
                          </button> */}

<div className="input-group-btn input-group-btn-sm">
    <button
        className="btn btn-sm btn-primary dropdown-toggle"
        id="btnVol"
        data-toggle="dropdown"
        title="Volume"
        style={{ background: 'none', border: 'none', boxShadow: 'none', fontSize: '18px', color: '#fff', padding: '4px 8px' }}
    >
        <i className="fa fa-fw fa-volume-up"></i>
    </button>
    <div className="dropdown-menu">
        <input
            type="range"
            min="0"
            max="100"
            defaultValue="100"
            step="1"
            id="sldVolume"
        />
    </div>
</div>

              </div>
          </div>

          <div className="well-sip">
            
            
              {/* <div id="sip-splash" className="text-muted text-center panel panel-default">
                  <div className="panel-body">
                      <h3 className="page-header">
                      <span className="fa-stack fa-2x">
                          <i className="fa fa-circle fa-stack-2x text-success"></i>
                          <i className="fa fa-phone fa-stack-1x fa-inverse"></i>
                      </span><br/>
                     </h3>
                      <p className="lead"></p>
                      <small></small>
                  </div>
              </div> */}

              {/* <div id="sip-splash" className="text-muted text-center panel panel-default">
                  <div className="panel-body">
                      <h3 className="page-header">
                      <span className="fa-stack fa-2x">
                          <i className="fa fa-circle fa-stack-2x text-success"></i>
                          <i className="fa fa-phone fa-stack-1x fa-inverse"></i>
                      </span><br/>
                     </h3>
                      <p className="lead"></p>
                      <small></small>
                  </div>
              </div> */}


  
                <div>
        <video id="localVideo" hidden  muted autoPlay width="300" height="240"  ref={videoRef}></video>
        </div>

  <div>
      <div className="sip-video-container">
        <video
          id="remoteVideo"
          autoPlay
          className="sip-video-remote"
           style={{ transform: `rotate(${rotation}deg)`, transition: 'transform 0.3s ease' }}
          ref={videoRef}
        ></video>
      </div>

      <div className="zoom-controls">
        <button onClick={handleRotate}>
          <FiRotateCw />
          Rotate
        </button>
        <button className="zoom-button" onClick={() => handleZoom(-0.1)}>
          − Zoom Out
        </button>
        <button className="zoom-button" onClick={() => handleZoom(0.1)}>
          + Zoom In
        </button>
      </div>
    </div>


   {/* <div className="call-card-wrapper">
        <div className="call-buttons">
          <button
            className="call-button audio"
            onClick={handleAudioCall}
            disabled={!callStatus.audio}
          >
            <FaPhoneAlt className="call-button-icon" />
            Audio Call
          </button>
  
          <button
            className="call-button video"
            onClick={handleVideoCall}
            disabled={!callStatus.video}
          >
            <FaVideo className="call-button-icon" />
            Video Call
          </button>
        </div>
      </div> */}


              <div id="sip-log" className="panel panel-default hide">
                  <div className="panel-heading">
                      <h4 className="text-muted panel-title">Recent Calls <span className="pull-right"><i className="fa fa-trash text-muted sipLogClear" title="Clear Log"></i></span></h4>
                  </div>
                  <div id="sip-logitems" className="list-group">
                      <p className="text-muted text-center">No recent calls from this browser.</p>
                  </div>
              </div>
          </div>

          <div className="modal fade" id="mdlError" tabIndex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
              <div className="modal-dialog modal-sm">
                  <div className="modal-content">
                      <div className="modal-header">
                          <h4 className="modal-title">Sip Error</h4>
                      </div>
                      <div className="modal-body text-center text-danger">
                          <h3><i className="fa fa-3x fa-ban"></i></h3>
                          <p className="lead">Sip registration failed. No calls can be handled.</p>
                      </div>
                  </div>
              </div>
          </div>

      </div>

      {/* <div className="text-center">
          <button type="button" id="btnSipCred" className="btn btn-primary" onClick={() => setIsVisible(true)} data-toggle="modal" data-target="#modalSipCredForm"><i className="fa fa-fw fa-phone-square"></i> SIP Credentials</button>      
      </div> */}

      {/* <div className="d-flex justify-content-between">
        <div>
        <video id="localVideo" muted autoPlay width="320" height="240"></video>
        </div>
        <div>
        <video id="remoteVideo" autoPlay width="320" height="240"></video>
        </div>
      </div> */}

      {isVisible && (
        <form className="modal fade in show" id="modalSipCredForm" tabIndex="-1" role="dialog" aria-labelledby="btnSipCred" aria-hidden="false" data-backdrop="false">
            <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span><span className="sr-only">Close</span>
                </button>
                <h4 className="modal-title" id="myModalLabel">Enter SIP Credentials</h4>
                </div>
                <div className="modal-body">
                <p>To use our demo you will need your SIP credentials from your account. All fields are required.</p>
                <div className="form-group">
                    <label>Display Name:</label>
                    <input type="text" name="Display" className="form-control" placeholder="i.e. Ben Franklin" 
                    value={accountData.Display} onChange={handleAccountData} required/>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                    <div className="form-group">
                        <label>Sip User:</label>
                        <input type="text" name="User" className="form-control" placeholder="i.e. sipuser" 
                        value={accountData.User} onChange={handleAccountData} required/>
                    </div>
                    </div>
                    <div className="col-sm-6">
                    <div className="form-group">
                        <label>WS URL:</label>
                        <input type="text" name="WSServer" className="form-control" placeholder="i.e. wss://sip.example.com:5060/" 
                        value={accountData.WSServer} onChange={handleAccountData} required/>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                    <div className="form-group">
                        <label>Sip Pass:</label>
                        <input type="password" name="Pass" className="form-control" placeholder="i.e. supaSekret!" 
                        value={accountData.Pass} onChange={handleAccountData} required/>
                    </div>
                    </div>
                    <div className="col-sm-6">
                    <div className="form-group">
                        <label>Sip Realm:</label>
                        <input type="text" name="Realm" className="form-control" placeholder="i.e. sip.example.com" 
                        value={accountData.Realm} onChange={handleAccountData} required/>
                    </div>
                    </div>
                </div>
                </div>
                <div className="modal-footer">
                <button type="button" className="btn btn-default" id="btnClose" data-dismiss="modal" onClick={() => setIsVisible(false)}>Close</button>
                <button type="button" className="btn btn-primary" id="btnSave" onClick={handleAccountSave}>Save</button>
                </div>
            </div>
            </div>
        </form>
    )}        
      <audio id="ringtone" src="/sounds/incoming.mp3" loop></audio>
      <audio id="ringbacktone" src="/sounds/outgoing.mp3" loop></audio>
      <audio id="dtmfTone" src="/sounds/dtmf.mp3"></audio>
      <audio id="audioRemote"></audio>
    </div>
    //   </ShadowDOM.div>
  );

}

export default CallPage;
